// extracted by mini-css-extract-plugin
var _1 = "sTcqK2Ke0h5kF9ViyFff";
var _2 = "FFtiSyYLVDbRYTCqZcZO";
var _3 = "HSi3OvEbpOzA7yL31_Og";
var _4 = "rrq3ER2qOT3zfFS9CyQH";
var _5 = "qGBp9aydoJ9iwCJ2JJwy";
export { _1 as "event", _2 as "eventButton", _3 as "eventconten", _4 as "rightside", _5 as "stdwindow" }
